/**
 * Route for `igaming-brand-overrides`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingBrandOverridesPage } from "../features/igaming-brand-overrides/IgamingBrandOverridesPage";

export const igamingBrandOverridesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-brand-overrides",
	component: IgamingBrandOverridesPage,
});

export default igamingBrandOverridesRoute;
